module.exports = __webpack_public_path__ + "portal-static/img/mp4_ico.211ff553.png";